/**
 * Created by lixinwei on 17/4/19.
 */
import * as types from './types'

const actions = {
    show_loading: ({
                       commit
                   }) => {
        return new Promise((resolve, reject) => {
            commit(types.SHOW_LOADING);
            resolve()
        });
    },

    hide_loading: ({
                       commit
                   }) => {
        return new Promise((resolve, reject) => {
            commit(types.HIDE_LOADING);
            resolve()
        });
    }

}
export default actions



// WEBPACK FOOTER //
// ./src/vuex/actions.js